/**
 * AddChannelSetCtrl controller
 *
 * @class AddChannelSetCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin*
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddChannelSetCtrl
 */

/* @ngInject */
export default function ContentItemIntersectionModalCtrl ($uibModalInstance, editedEntity, itemWithIntersection, checkIntersection, contentSetsIntersectionBySubscriptionId, contentSetsIntersectionByContentSetId) {
  const vm = this

  vm.contentSetsIntersectionBySubscriptionId = contentSetsIntersectionBySubscriptionId
  vm.contentSetsIntersectionByContentSetId = contentSetsIntersectionByContentSetId
  vm.contentType = editedEntity.$itemTypeName || editedEntity.$itemType.replace(/^./, str => str.toUpperCase())
  vm.info = `The ${vm.contentType} "${editedEntity.name}" intersects in the following content sets within the following Subscriptions.`
  vm.hint = 'The same content can be attached to Subscription as basic or monetized per item only once.'
  vm.openFooter = window.innerHeight > 750
  vm.editedEntity = editedEntity
  vm.itemWithIntersection = itemWithIntersection

  vm.checkIntersection = function () {
    checkIntersection()
      .then(() => {
        if (!vm.itemWithIntersection.conflicts) {
          $uibModalInstance.dismiss()
        }
      })
  }

  vm.close = $uibModalInstance.dismiss
}
